// Trending products carousel
document.addEventListener('DOMContentLoaded', function() {
    try {
        const swiper = new Swiper('.swiper-trending-products', {
        direction: 'horizontal',
        pagination: {
            el: '.swiper-pagination-trending-products',
            clickable: true
        },
        navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next'
        },
        autoplay: false,
        breakpoints: {
            320: {
            slidesPerView: 1,
            spaceBetween: 20
            },
            767: {
            slidesPerView: 2,
            spaceBetween: 30
            },
            1200: {
            slidesPerView: 3,
            spaceBetween: 40
            },
            1600: {
            slidesPerView: 4.2,
            spaceBetween: 60
            }
        }
        })
    } catch (e) {
        console.log("SwiperJS is not defined");
    }
})

// USPs Carousel
document.addEventListener('DOMContentLoaded', function() {
    try {
        const swiper = new Swiper('.swiper-usps', {
        direction: 'horizontal',
        autoplay: {
            delay: 2500,
          },
        breakpoints: {
            320: {
            slidesPerView: 1,
            spaceBetween: 20
            },
            767: {
            slidesPerView: 2,
            spaceBetween: 30
            },
            992: {
            slidesPerView: 3,
            spaceBetween: 40
            },
            1200: {
            slidesPerView: 5,
            spaceBetween: 60
            }
        }
        })
    } catch (e) {
        console.log("SwiperJS is not defined");
    }
})

document.addEventListener('DOMContentLoaded', function() {
    try {
        const swiper = new Swiper('.testimonials-swiper', {
        direction: 'horizontal',
        slidesPerView: 1,
        pagination: {
            el: '.testimonials-pagination',
            clickable: true
        },
        autoplay: {
            delay: 5000,
        },
        breakpoints: {
            320: {
            slidesPerView: 1,
            spaceBetween: 20
            },
            992: {
            slidesPerView: 3,
            spaceBetween: 40
            }
        }
        })
    } catch (e) {
        console.log("SwiperJS is not defined");
    }
})

// Testimonials publications Carousel
document.addEventListener('DOMContentLoaded', function() {
    try {
        const swiper = new Swiper('.swiper-publication-testimonials', {
        direction: 'horizontal',
        slidesPerView: 1,
        pagination: {
            el: '.swiper-testimonials-publications-pagination',
            clickable: true
        },
        autoplay: {
            delay: 5000,
          },
        breakpoints: {
            320: {
            slidesPerView: 1,
            spaceBetween: 20
            },
            992: {
            slidesPerView: 2,
            spaceBetween: 30
            },
            1200: {
            slidesPerView: 3,
            spaceBetween: 40
            }
        }
        })
    } catch (e) {
        console.log("SwiperJS is not defined");
    }
})

// Testimonials publications Carousel
document.addEventListener('DOMContentLoaded', function() {
    try {
        const swiper = new Swiper('.swiper-blog', {
        direction: 'horizontal',
        pagination: {
            el: '.swiper-blog-pagination',
            clickable: true
        },
        autoplay: {
            delay: 5000,
          },
        breakpoints: {
            320: {
            slidesPerView: 1,
            spaceBetween: 20
            },
            992: {
            slidesPerView: 2,
            spaceBetween: 30
            },
            1200: {
            slidesPerView: 3,
            spaceBetween: 40
            }
        }
        })
    } catch (e) {
        console.log("SwiperJS is not defined");
    }
})

// Product page image Swiper
document.addEventListener('DOMContentLoaded', function() {
    try {
        const swiper = new Swiper('.pdp-image-swiper', {
        direction: 'horizontal',
        slidesPerView: 1,
        loop: true,
        pagination: {
            el: '.pdp-image-swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.pdp-image-swiper-button-next',
            prevEl: '.pdp-image-swiper-button-prev',
        },
        autoplay: {
            delay: 5000,
          },
        })
    } catch (e) {
        console.log("SwiperJS is not defined");
    }
})
